import React from 'react';
import { Plus } from 'lucide-react';
import { highlightText } from '../../../utils/highlightText';
import { INTENT_LABELS, formatPosition, pad2 } from '../format';

const SampleDots = ({ appearances, samples }) => (
  <span className="flex items-center gap-1.5" aria-hidden="true">
    {Array.from({ length: samples }, (_, i) => (
      <span key={i} className={`rp-dot ${i < appearances ? 'rp-dot--hit' : ''}`} />
    ))}
  </span>
);

const QuestionsList = ({ report }) => {
  const { business, questions } = report;

  return (
    <ol className="border-t border-[var(--lp-line)]">
      {questions.map((q, i) => {
        const winner = q.mentions[0];
        // One answer per question: say yes/no instead of "1 de 1".
        const single = q.samples === 1;
        return (
          <li key={q.id} className="rp-keep border-b border-[var(--lp-line)] py-7">
            <div className="grid gap-5 md:grid-cols-[1fr_20rem] md:gap-10">
              <div>
                <div className="flex flex-wrap items-center gap-3">
                  <span className="lp-mono text-xs text-[var(--lp-muted)]">P{pad2(i + 1)}</span>
                  <span className="rounded-full border border-[var(--lp-line)] px-2.5 py-0.5 text-xs text-[var(--lp-muted)]">
                    {INTENT_LABELS[q.intent]}
                  </span>
                </div>
                <p className="mt-3 text-xl font-semibold tracking-[-0.02em]">{q.text}</p>
              </div>

              <div className="space-y-3 text-sm">
                <p className="flex items-center justify-between gap-4">
                  <span className="text-[var(--lp-muted)]">Tú</span>
                  <span className="flex items-center gap-3">
                    <SampleDots appearances={q.appearances} samples={q.samples} />
                    <span className="font-semibold tabular-nums">
                      {single ? (q.appearances ? 'Te nombra' : 'No te nombra') : `${q.appearances} de ${q.samples}`}
                      {q.bestPosition && (
                        <span className="font-normal text-[var(--lp-muted)]"> · {formatPosition(q.bestPosition)}</span>
                      )}
                    </span>
                  </span>
                </p>
                {winner && (
                  <p className="flex items-center justify-between gap-4">
                    <span className="text-[var(--lp-muted)]">{single ? 'Primer competidor' : 'Gana'}</span>
                    <span className="text-right font-semibold">
                      {winner.name}
                      {!single && (
                        <span className="font-normal tabular-nums text-[var(--lp-muted)]">
                          {' '}
                          {winner.appearances} de {q.samples}
                        </span>
                      )}
                    </span>
                  </p>
                )}
              </div>
            </div>

            <details className="lp-faq mt-5">
              <summary className="inline-flex items-center gap-2 text-sm font-semibold">
                <Plus size={16} className="lp-faq-icon text-[var(--lp-lime)] transition-transform" aria-hidden="true" />
                Ver una respuesta real de la IA
              </summary>
              <p className="mt-4 rounded-[20px] bg-[var(--lp-paper)] p-5 text-[15px] leading-relaxed text-[var(--lp-ink)] sm:p-6">
                {highlightText(q.exampleAnswer, business.name, 'rounded bg-[var(--lp-lime)] px-1')}
              </p>
            </details>
          </li>
        );
      })}
    </ol>
  );
};

export default QuestionsList;
